// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import RoomListPagingResultModel from '../../model/room-list-paging-result-model';
import RoomListPagingResultDTO from '../dto/room-list-paging-result-dto';
import dtoSchema from '../schemas/room-list-paging-result-schema';
import RoomListModel from '../../model/room-list-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class RoomListPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<RoomListPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => RoomListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: RoomListModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<RoomListPagingResultDTO>): RoomListPagingResultModel;
  static toModel(dto: DeepPartial<RoomListPagingResultDTO> | undefined | null): RoomListPagingResultModel | undefined;
  static toModel(dto: DeepPartial<RoomListPagingResultDTO> | undefined | null): RoomListPagingResultModel | undefined {
    return dto ? new RoomListPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<RoomListPagingResultModel> | RoomListPagingResultModel): RoomListPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as RoomListPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for RoomListPagingResultModel, can not map to RoomListPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
